import { SELECT_CAT } from '../actions/selectedCat';
export var selectedCat = function selectedCat() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SELECT_CAT:
      return action.selectedCat;
    default:
      return state;
  }
};